 <template>
  <div class="title">
    <v-btn
      small
      class="zoom-btn zoom"
      ref="zoomBtn"
      height="60"
      width="60"
      @click="zoomIn()"
    >
      <v-icon>mdi-magnify-plus</v-icon>
      <div class="zoom-btn-txt">
        <!-- Zoom To -->
        Zoom To<br />District
      </div>
    </v-btn>

    <v-icon
      elevation="2"
      color="black"
      class="zoom-btn close"
      @click="clearResults()"
    >
      mdi-close</v-icon
    >
    <a class="share-dist" @click="EventBus.$emit('open-modal', 'share')"
      ><v-icon color="black">mdi-share-variant-outline</v-icon> Share</a
    >

    <p @click="toggleMenu()" class="title district-state">
      <span v-show="district && state">
        {{ district }}<br />in {{ state }}
        <!-- <div v-show="propub.name" class="representative-name-title-bar">Rep. {{ propub.name }} ({{ propub.party }})</div> -->
        <!-- <div
          v-show="rep && party && !singleDistState && !multimember"
          class="representative-name-title-bar"
        >
          {{ honorific }} {{ rep }} ({{ party }})
        </div>
        <div v-show="multimember" class="representative-name-title-bar">
          Multimember District
        </div> -->
      </span>
      <!-- <span v-show="!district"> Looking for<br />district...</span> -->
      <span class="title-placeholder" v-show="!district">
        Gathering data...</span
      >
    </p>
  </div>
</template>
<script>
import { EventBus } from "../../../data/EventBus";
import { Enums } from "../../../data/Config/Config";
export default {
  name: "SelectedDistrictTitle",
  props: [
    "district",
    "state",
    "rep",
    "party",
    "singleDistState",
    "multimember",
  ],
  data: function () {
    return {
      EventBus: EventBus,
    };
  },
  watch: {},
  methods: {
    zoomIn() {
      //console.log('zoom')
      EventBus.$emit("zoomIn");
    },
    clearResults() {
      this.$store.commit("setSelectedData", {});
      this.$store.commit("setSelectedPoint", {});
      this.$store.commit("setSelectedAddress", {});
      EventBus.$emit("clear-data");
    },
    toggleMenu() {
      console.log('toggle')
      this.$store.commit(
        "setSidePanelOpen",
        !this.$store.getters.getSidePanelOpen
      );
    },
  },
  computed: {
    propub: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.PROPUB] || {}
      );
    },
    postgres: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
    honorific: function () {
      switch (this.$store.getters.getDistrictType) {
        case Enums.LEG_BODY.CONGRESS:
          return "Rep.";
        case Enums.LEG_BODY.ST_LOWER:
        case Enums.LEG_BODY.ST_UPPER:
          return "Hon.";
        default:
          return "";
      }
    },
  },
};
</script>
<style scoped>
.share-dist i {
  font-size: 1.2em;
  padding-bottom: 3px;
}

.share-dist {
  display: inline-block;
  /* margin: 5px 0; */
  font-size: 0.6em;
  position: absolute;
  bottom: -2px;
  right: 0px;
  width: 60px;
  z-index: 1;
  padding: 0;
  text-align: center;
}
.zoom-btn {
  margin: 5px auto 0 auto;
  display: block;
  position: absolute;
  z-index: 1;
}

.zoom-btn.zoom {
  margin-left: 5px;
  padding: 0 !important;
}

.zoom-btn-txt {
  font-size: 9px;
  padding: 5px 0;
}
.zoom-btn.close {
  right: 5px;
  top: -5px;
}

.title.district-state {
  min-height: 70px;
  margin-bottom: 0;
  max-width: 95%;
}

.representative-name-title-bar {
  font-size: 0.7em;
  font-style: italic;
  color: #404040;
  /* margin-bottom: 5px; */
}
</style>

<style>
#print-container .title-placeholder {
  display: none;
}
</style>